// TabLabelWithAttention — a tab's text label plus, when the tab needs
// attention, a small red dot AND a visually-hidden "needs attention" suffix.
// Shared by the primary and overflow rows of the contract tab bar so the inline
// indicator is identical in both. The dot is decorative (aria-hidden); the
// sr-only suffix folds the cue into the tab's own accessible name, so a VISIBLE
// attention tab is announced to screen readers even when no More button exists
// (wide viewport, pulled-forward active, or no overflow). For HIDDEN tabs the
// More button's accessible name carries the cue instead.

interface TabLabelWithAttentionProps {
  label: string;
  attention?: boolean;
}

export default function TabLabelWithAttention({
  label,
  attention,
}: TabLabelWithAttentionProps) {
  return (
    <>
      {label}
      {attention && (
        <>
          <span
            aria-hidden="true"
            className="ml-1.5 inline-block h-[7px] w-[7px] shrink-0 rounded-full bg-red-500 dark:bg-red-600"
          />
          <span className="sr-only">, needs attention</span>
        </>
      )}
    </>
  );
}
